import React from 'react'
import PropTypes from 'prop-types'

function ChildRow({ images, formats }) {
  return (
    <td colSpan={9} className="table__child-row">
      <div className="detailed-info">
        <div className="detailed-info__section-title">Formats:</div>
        {formats.length > 0
          && (
          <ul className="list--horizontal">
            {formats.map((format, index) => <li key={index}>{format.name}</li>)}
          </ul>
          )
        }
      </div>

      <div className="detailed-info">
        <span className="detailed-info__section-title">Images:</span>
        {images.length > 0
          && (
          <ul className="list--horizontal">
            {images.map((image, index) => <li key={index}>{image.name}</li>)}
          </ul>
          )
        }
      </div>
    </td>
  )
}

ChildRow.propTypes = {
  images: PropTypes.array.isRequired,
  formats: PropTypes.array.isRequired,
}

export default ChildRow
